import { useGameStore } from '../store/gameStore';
import { getGuestName } from '../lib/guestName';

// The tab bar for the four top-level screens. It used to be copy-pasted into
// Home and Profile only, so Leaderboard and Solo Setup stranded the player
// with nothing but the back arrow (first piece of tester feedback on v6).
// One component, rendered by App for every top-level view, active state from
// the store.
const TABS = [
  {
    view: 'home' as const,
    id: 'nav-home',
    path: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z',
  },
  {
    view: 'config' as const,
    id: 'nav-realms',
    path: 'M3 3h8v8H3V3zm10 0h8v8h-8V3zM3 13h8v8H3v-8zm10 0h8v8h-8v-8z',
  },
  {
    view: 'profile' as const,
    id: 'nav-profile',
    path: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z',
  },
  {
    view: 'leaderboard' as const,
    id: 'nav-leaderboard',
    path: 'M19 5h-2V3H7v2H5c-1.1 0-2 .9-2 2v1c0 2.55 1.92 4.63 4.39 4.94A5.01 5.01 0 0011 15.9V19H7v2h10v-2h-4v-3.1a5.01 5.01 0 003.61-2.96C19.08 12.63 21 10.55 21 8V7c0-1.1-.9-2-2-2zM5 8V7h2v3.82C5.84 10.4 5 9.3 5 8zm14 0c0 1.3-.84 2.4-1.98 2.82V7h2v1z',
  },
];

export function BottomNav() {
  const view = useGameStore((s) => s.view);
  const nickname = useGameStore((s) => s.nickname);
  const setNickname = useGameStore((s) => s.setNickname);
  const setGameMode = useGameStore((s) => s.setGameMode);
  const setView = useGameStore((s) => s.setView);

  const go = (target: (typeof TABS)[number]['view']) => {
    if (target === view) return;
    if (!nickname.trim()) setNickname(getGuestName());
    if (target === 'config') setGameMode('solo');
    setView(target);
  };

  return (
    <nav className="bottom-nav" id="main-nav">
      {TABS.map((t) => (
        <button
          key={t.view}
          className={`nav-item ${view === t.view ? 'active' : ''}`}
          id={t.id}
          onClick={() => go(t.view)}
        >
          <svg className="nav-icon" viewBox="0 0 24 24" fill="currentColor">
            <path d={t.path} />
          </svg>
        </button>
      ))}
    </nav>
  );
}
